import { BoundForError } from '@/libs/BoundForError'

export class BoardError extends BoundForError {}
